type AppEnvironment = "local" | "test" | "prod";

function getEnvironmentForApp(): AppEnvironment {
    let env: AppEnvironment = undefined;
    const hostname = window.location.hostname;

    if (hostname === "localhost") {
        env = "local";
    } else if (
        hostname === "test.lifeat.app" ||
        hostname === "beta.lifeat.app" ||
        process.env.APP_HOST_NAME === "test.lifeat.app"
    ) {
        env = "test";
    } else if (hostname === "lifeat.io" || process.env.APP_HOST_NAME === "lifeat.io") {
        env = "prod";
    }

    return env;
}

export { getEnvironmentForApp };
